import Vue from 'vue';
import Router from 'vue-router';

import superPunchClockRoutes from './superPunchClock';
import invitationRoutes from './invitation';
import hackerRoutes from './hacker';
import hlw from './hlw';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: '/travel',
  routes: [
    ...superPunchClockRoutes,
    ...invitationRoutes,
    ...hackerRoutes,
    ...hlw
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/travel/index.js